/** Staff task calls. Shapes follow workers/api/src/home/tasks.ts on `main`. */
import type { ApiClient } from "./client";

export interface TaskLink { type: "member" | "lead"; id: string }
export interface TaskItem {
  id: string;
  title: string;
  notes?: string | null;
  branchId: string;
  assigneeStaffId: string;
  assigneeName?: string | null;
  createdByStaffId?: string;
  dueDate: string | null;
  dueTime: string | null;
  link?: TaskLink | null;
  doneAt: number | null;
  doneBy?: string | null;
  overdue?: boolean;
}
export interface TasksResult { tasks: TaskItem[]; truncated: boolean }
export interface TaskQuery { assignee?: "me" | string; status?: "open" | "done"; date?: string }

export async function listTasks(c: ApiClient, q: TaskQuery): Promise<TasksResult> {
  const r = await c.get<{ tasks?: TaskItem[]; items?: TaskItem[]; truncated?: boolean }>("/tasks", { assignee: q.assignee ?? "me", status: q.status, date: q.date });
  return { tasks: r.tasks ?? r.items ?? [], truncated: r.truncated ?? false };
}
export interface NewTask { title: string; notes?: string; branchId?: string; assigneeStaffId?: string; dueDate?: string | null; dueTime?: string | null; link?: TaskLink }
export const createTask = (c: ApiClient, v: NewTask) => c.post<{ task: TaskItem }>("/tasks", v);
export const patchTask = (c: ApiClient, id: string, v: Partial<Omit<NewTask, "branchId">>) => c.patch<{ task: TaskItem }>(`/tasks/${id}`, v);
export const doneTask = (c: ApiClient, id: string) => c.post<unknown>(`/tasks/${id}/done`);
export const reopenTask = (c: ApiClient, id: string) => c.post<unknown>(`/tasks/${id}/reopen`);
export const deleteTask = (c: ApiClient, id: string) => c.del<unknown>(`/tasks/${id}`);
